import styled from "@emotion/styled";

export const Date = styled.span``;
